export enum TrackingNeologicaRegistrationEvent {
  explore_without_enabling = 'explore_without_enabling',
  enable_broker = 'enable_broker',
  close_popup = 'close_popup'
}
